
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.781 6L.156.86A.453.453 0 010 .507C0 .368.052.25.156.156A.453.453 0 01.508 0c.14 0 .258.052.351.156l6 5.469c.052.052.089.11.11.172.02.062.031.13.031.203 0 .073-.01.14-.031.203a.438.438 0 01-.11.172l-6 5.469A.454.454 0 01.508 12a.454.454 0 01-.352-.156.454.454 0 01-.156-.352c0-.14.052-.258.156-.351L5.781 6z","fill":"#1D1D1D"}})])
          )
        }
      }
    